export const sectionPropertyState = {
  FILLED: 'FILLED',
  NOT_FILLED: 'NOT_FILLED',
  NOT_SUFFICIENT: 'NOT_SUFFICIENT',
};

export const propertySections = {
  PROPERTY_DETAILS: 'PROPERTY_DETAILS',
  PROPERTY_ADDRESS: 'PROPERTY_ADDRESS',
  ACCEPTANCE_CRITERIA: 'ACCEPTANCE_CRITERIA',
  PROPERTY_FACILITY: 'PROPERTY_FACILITY',
  ROOM_CONFIG: 'ROOM_CONFIG',
  PRICE_AND_AVAILABILITY: 'PRICE_AND_AVAILABILITY',
  PRICE_CALC_DISPLAY: 'PRICE_CALC_DISPLAY',
  PAYMENT_PLAN: 'PAYMENT_PLAN',
  GALLERY_MANAGEMENT: 'GALLERY_MANAGEMENT',
};

export const allPropertySections = {
  ...propertySections,
  PAYMENT_METHOD: 'PAYMENT_METHOD',
};

export const noAcPropertySection = {
  PROPERTY_DETAILS: 'PROPERTY_DETAILS',
  PROPERTY_ADDRESS: 'PROPERTY_ADDRESS',
  PROPERTY_FACILITY: 'PROPERTY_FACILITY',
  ROOM_CONFIG: 'ROOM_CONFIG',
  PRICE_AND_AVAILABILITY: 'PRICE_AND_AVAILABILITY',
  PRICE_CALC_DISPLAY: 'PRICE_CALC_DISPLAY',

  GALLERY_MANAGEMENT: 'GALLERY_MANAGEMENT',
};
export const propertyStatus = {
  NEW: 'NEW',
  EDITING: 'EDITING',
  PUBLISHED: 'PUBLISHED',
  UNPUBLISHED: 'UNPUBLISHED',
};

export const roomCategory = {
  SHARED_ROOM: 'SHARED_ROOM',
  PRIVATE_ROOM: 'PRIVATE_ROOM',
  ENTIRE_PLACE: 'ENTIRE_PLACE',
};

export const propertyTenancyAgreementCalculateType = {
  BEFORE: 'BEFORE',
  BEFORE_OR_ON: 'BEFORE_OR_ON',
  ON: 'ON',
  AFTER: 'AFTER',
  AFTER_OR_ON: 'AFTER_OR_ON',
};

export const propertyTenancyAgreementField = {
  MOVE_IN_DATE: 'MOVE_IN_DATE',
};

export const propertyTenancyAgreementTimeType = {
  ANYTIME: 'ANYTIME',
  FIXED: 'FIXED',
};

export const propertyTenancyAgreementUnit = {
  DAY: 'DAY',
};

export const inventoryType = {
  ROOM_COUNT: 'ROOM_COUNT',
};

export const other = {};

export const documentationTimeValue = {
  BEFORE_SUBMIT_ORDER: 'before_submit_order',
};
